import { defaultOptions, Bar } from '.';
import useDevicesStore from 'store/devices';
import { LoadingIndicator } from '@thermon-platforms/thermon-ui-core';
import { merge } from 'lodash';
import { useNavigate } from 'react-router-dom';
import { getDeviceUrl } from 'util/device';

/**
 * @function AlarmsByDevice
 * @memberof module:Charts
 * @description Bar chart for showing alarms per given device
 *
 * @param {object} props
 * @param {object} props.data
 * @param {boolean} props.loading
 * @returns React.Element
 *
 * @example
 * <AlarmsByDevice data={data} loading={loading} />
 */
function AlarmsByDevice({data, loading=false}) {
  const [devicesStore] = useDevicesStore();
  const navigate = useNavigate();
  return (
    <>
    {loading ? <LoadingIndicator /> :
      <Bar
        options={merge(defaultOptions.bar, {
          backgroundColor: 'rgba(224,102,102,1)',
        }, {
          indexAxis: 'y',
          onClick: (event, array, chart) => {
            if (!array?.[0]) return;
            const deviceId = chart.data.labels[array[0].index];
            const device = devicesStore.shallowDevices.get(deviceId);
            navigate(getDeviceUrl(device));
          },
          plugins: {
            tooltip: {
              callbacks: {
                title: (array) => {
                  return devicesStore.shallowDevices.get(array[0].label)?.model.name;
                }
              }
            }
          },
          scales: {
            x: {
              stacked: true
            },
            y: {
              ticks: {
                callback: function(val) {
                  const deviceId = this.chart.data.labels[val];
                  return devicesStore.shallowDevices.get(deviceId)?.model.name;
                }
              },
              stacked: true
            }
          }
        })}
        data={data}
      />
    }
    </>
  );
}

export default AlarmsByDevice;
